import { FC } from 'react';
import { Section1, Section2, Section3, Links, Images } from './article9_model';
import '../ArticleComponent.scss';
import './Article9.scss';
const Article9Component: FC = () => {
	return (
		<div className='page'>
			<div className='section--intro'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section1.heading}</h3>
					<p className='info-600'>
						<span>{Section1.para1.content1}</span>
						<a href={Links.newtopia_now} className='info-600' target='_blank' rel='noopener'>
							{Section1.para1.content2_link}
						</a>
						<span>{Section1.para1.content3}</span>
						<a href={Links.beacon_discovery} className='info-600' target='_blank' rel='noopener'>
							{Section1.para1.content4_link}
						</a>
						.
					</p>
					<p className='info-400'>
						<span>{Section1.para2.content1}</span>
						<a href={Links.trade_show} target='_blank' rel='noopener'>
							{Section1.para2.content2_link}
						</a>
						<span>{Section1.para2.content3}</span>
						<a href={Links.four_neighbourhoods} target='_blank' rel='noopener'>
							{Section1.para2.content4_link}
						</a>
						<span>{Section1.para2.content5}</span>
					</p>
					<br></br>
					<br></br>

					<p className='info-400'>{Section1.para3}</p>
					<div className='middle-image'>
						<img src={Images.jeena_mathews_connection} className='non-clickable'></img>
					</div>
				</div>
			</div>

			<div className='section--noimage nine-first'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section2.heading}</h3>
					<p className='info-600'>
						<span>{Section2.para1.content1}</span>
						<a
							href={Links.standard_applications_form}
							className='info-600'
							target='_blank'
							rel='noopener'
						>
							{Section2.para1.content2_link}
						</a>
						<span>{Section2.para1.content3}</span>
					</p>
					<p className='info-400'>{Section2.para2}</p> <br></br>
					<br></br>
					<p className='info-400'>{Section2.para3}</p> <br></br>
					<br></br>
					<p className='info-400'>{Section2.para4}</p> <br></br>
					<br></br>
					<p className='info-400'>{Section2.para5}</p>
				</div>
			</div>

			<div className='section--noimage nine-second'>
				<div className='section-container'>
					<h3 className='section-heading'>{Section3.heading}</h3>
					<p className='info-600'>{Section3.para1}</p>
					<p className='info-400'>{Section3.li.heading}</p>
					<br></br>
					<br></br>
					<ol>
						<li>
							<span>{Section3.li.l1.content}</span>
							<a href={Links.standard_applications_form} target='_blank' rel='noopener'>
								{Section3.li.l1.content_link}
							</a>
							.
						</li>

						<li>
							<span>{Section3.li.l2.content1}</span>
							<a href={Links.beacon_discovery} target='_blank' rel='noopener'>
								{Section3.li.l2.content2_link}
							</a>
							.<span>{Section3.li.l2.content3}</span>
							<span>{Section3.li.l2.content4}</span>
						</li>
						<li>{Section3.li.l3}</li>
						<li>{Section3.li.l4}</li>
						<li>{Section3.li.l5}</li>
					</ol>
					<p className='info-400'>
						<span>{Section3.para2.content1}</span>
						<a href={Links.newtopia_now} target='_blank' rel='noopener'>
							{Section3.para2.content2_link}
						</a>
						<span>{Section3.para2.content3}</span>
					</p>
				</div>
			</div>
		</div>
	);
};

export default Article9Component;
